import GlobalDataCache from 'models/globalDataCache/globalDataCache';
import { StoreMgmtStates } from './adminTenant';
import { addDateDays, getDateTimeDiffHours } from 'utils/datetime';
import { globalTrialLengthDays } from 'globalConstants';
import Tenant from './tenant';
import { SubscriptionTypes } from 'utils/subscription';
import { IdentityProviderType } from './identityProvider';

export default class Login {
  tenantId: string; //tenant id that the back-end returns. can be an org. unit id

  userId?: string;

  //the identity provider the user signed in with, and the one the resolved tenant is registered with
  identityProviderType: IdentityProviderType;

  tenantIdentityProviderType: IdentityProviderType;

  lastLogin?: Date;

  tenantLicensed: boolean;

  userLicensed: boolean;

  userSystemRoles?: number[];

  userCustomRoles?: string[];

  permissions?: number[];

  userLanguageCode?: string;

  defLanguageCode: string;

  trialStart?: Date;

  globalDataCache: GlobalDataCache;

  isGuest: boolean;

  isOrgUnit: boolean;

  //true when the current org unit is linked to its own directory (different from the top level parent's)
  orgUnitHasSeparateIdentityProvider: boolean;

  //true when this session is a read-only preview of a backup checkpoint
  isCheckpointPreview: boolean;

  storeMgmtState: StoreMgmtStates;

  subscriptionType: number;

  leadSource?: string;

  partnerId?: string;

  isPartner: boolean;

  tenants: Tenant[];

  isOnboardingInProgress: boolean;

  //true while the first run of the set-up has not finished, trial or converted; offers the Welcome tab and the
  //wizard, never hides the menu (that is the server's isOnboardingInProgress, kept in the app context)
  hasUnfinishedOnboarding: boolean;

  constructor() {
    this.tenantId = '';
    this.identityProviderType = IdentityProviderType.Entra;
    this.tenantIdentityProviderType = IdentityProviderType.Entra;
    this.tenantLicensed = false;
    this.userLicensed = false;
    this.defLanguageCode = '';
    this.globalDataCache = new GlobalDataCache();
    this.isGuest = false;
    this.isOrgUnit = false;
    this.orgUnitHasSeparateIdentityProvider = false;
    this.isCheckpointPreview = false;
    this.storeMgmtState = StoreMgmtStates.Customer;
    this.subscriptionType = SubscriptionTypes.Basic;
    this.isPartner = false;
    this.tenants = [];
    this.isOnboardingInProgress = false;
    this.hasUnfinishedOnboarding = false;
  }

  isInTrial(): boolean {
    if (!this.trialStart) return false;

    return true;
  }

  trialEnded(): boolean {
    if (!this.trialStart) return false;
    const trialEnd = this.trialEnd();
    if (!trialEnd) return false;
    const trialOverDueHours = getDateTimeDiffHours(trialEnd, new Date());

    return trialOverDueHours < 0;
  }

  trialDaysLeft(): number {
    if (!this.trialStart) return -1;
    const trialEnd = this.trialEnd();
    if (!trialEnd) return -1;
    const trialOverDueHours = getDateTimeDiffHours(trialEnd, new Date());
    if (trialOverDueHours < 0) return 0;

    return Math.ceil(trialOverDueHours / 24);
  }

  trialEnd(): Date | undefined {
    if (!this.trialStart) return undefined;

    return addDateDays(this.trialStart, globalTrialLengthDays);
  }
}
